"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkSpecialCharsAndEmpty = void 0;

var checkSpecialCharsAndEmpty = function checkSpecialCharsAndEmpty(value) {
  var thisValue = value.toString().toLowerCase();
  var hasSpecialChars = false;

  if (typeof value === 'string') {
    hasSpecialChars = thisValue.length === 0 || /[\n\t,;."'`´ ]/.test(thisValue);
  }

  return hasSpecialChars;
};

exports.checkSpecialCharsAndEmpty = checkSpecialCharsAndEmpty;


//////////////////
// WEBPACK FOOTER
// ./~/convert-array-to-csv/lib/helpers/check-special-chars-and-empty.js
// module id = 81
// module chunks = 0